import React from 'react';

import { Col, Cols, Row, Rows, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { useReportBuilderStore } from '~/src/dash/views/ias-publisher/IASReportBuilder/contexts';
import { ISection } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';

interface IReportSectionsProps extends ISection {
  icon: any;
  title: string;
  component: any;
}

export const Sections = ({ icon, title, component }: IReportSectionsProps) => {
  const { props } = useReportBuilderStore();
  return (
    <Rows
      responsive
      style={{
        borderBottom: `1px solid ${publicaColors.lightGray}`,
      }}
    >
      <Row
        style={{
          alignItems: 'center',
        }}
      >
        <Cols wrap responsive>
          {/* icon for the row */}
          <Col
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
            paddingRight='16px'
          >
            <img src={icon} />
          </Col>
          {/* title for the row */}
          <Col>
            <Text subheader>{title}</Text>
          </Col>
        </Cols>
      </Row>
      {/* paddingLeft 50px because the title of the header is 50px from the left */}
      <Row paddingLeft='50px' noPadding>
        {component(props)}
      </Row>
    </Rows>
  );
};
